import React, { useState } from 'react'
import {
  Box,
  Spinner,
  Center,
  Flex,
  Heading,
  Button,
  Icon,
} from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { FaPlus } from 'react-icons/fa'

import { whitelistService } from '../services/api'
import DataWhitelistTable from '../components/DataWhitelistTable'
import AddWhitelistModal from '../components/AddWhitelistModal'

const DataPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['id'],
    queryFn: async () => {
      const response = await whitelistService.getWhitelist()
      return response.data || { entries: [], count: 0 }
    },
  })

  return (
    <Box p={4}>
      {isLoading && !data ? (
        <Center h="60vh">
          <Spinner size="xl" color="blue.500" />
        </Center>
      ) : (
        <>
          <Flex justify="space-between" align="center" mb={6}>
            <Heading size="lg">
              Data Whitelist
            </Heading>
            <Button
              size="sm"
              colorScheme="blue"
              leftIcon={<Icon as={FaPlus} />}
              onClick={() => setIsModalOpen(true)}
            >
              Add to Whitelist
            </Button>
          </Flex>

          <DataWhitelistTable
            data={data}
            isLoading={isLoading}
            refetch={refetch}
            error={error}
          />

          <AddWhitelistModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSuccess={refetch}
          />
        </>
      )}
    </Box>
  )
}

export default DataPage
